/** Compatibility export; the business domain owns this implementation. */
export { IAmazonMbaFitTypes, IAmazonMbaMarketplace, IAmazonMbaPrint, IAmazonMbaProduct, IColors, MBA_PRODUCT_SPECIFICATION } from '@domains/upload/shared';
